<template>
  <NavBarWeb/>
  <div class="sectionKoko container mt-5">

    Coming soon

  </div>
  <FooterWeb/>
</template>

<script>

import NavBarWeb from "../components/NavBarWeb";
import FooterWeb from "../components/FooterWeb";

export default {
  name: "Press",
  components:{
    FooterWeb,
    NavBarWeb
  }
}
</script>

<style scoped>
.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}
</style>

